import { render, staticRenderFns } from "./CompanyNotificationsButton.vue?vue&type=template&id=b8169402"
import script from "./CompanyNotificationsButton.vue?vue&type=script&lang=ts"
export * from "./CompanyNotificationsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8169402')) {
      api.createRecord('b8169402', component.options)
    } else {
      api.reload('b8169402', component.options)
    }
    module.hot.accept("./CompanyNotificationsButton.vue?vue&type=template&id=b8169402", function () {
      api.rerender('b8169402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyNotificationsButton.vue"
export default component.exports